import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const Dl = ({ o, oc, t, tc, m, bt, btc, bc, bch, bcf, bcfc, bcfh, bcft }) => {
  return (
    <Dialog open={o} onClose={oc} sx={{maxWidth: "auto",  width: "auto", margin: "auto",overflow: "visible", }}>
      <DialogTitle sx={{ color: tc ,fontSize: "1.3rem",fontWeight: "400",textAlign: "left",padding: "5px",minHeight: "30px",whiteSpace: "pre-wrap",paddingRight: "40px", }}>{t}</DialogTitle>
      <IconButton onClick={oc} sx={{position: "absolute",right: "5px",top: "3px",borderRadius: "8px", }}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ fontSize: "1rem",maxHeight: "100%", overflowY: "auto", paddingBottom: "0",whiteSpace: "pre-wrap",wordBreak: "break-word",textAlign: "center", }}>{m}</DialogContent>
      <DialogActions sx={{display: "flex", justifyContent: "center", alignItems: "center",marginTop: "20px",}}>
        {bcf && (
          <Button
            variant="contained"
            onClick={bcf}
            sx={{
                backgroundColor: bcfc,
                color: btc,
                "&:hover": { backgroundColor: bcfh },
            }}
          >
            {bcft}
          </Button>
        )}
        <Button
          onClick={oc}
          variant="contained"
          autoFocus
          sx={{
            backgroundColor: bc,
            color: btc,
            "&:hover": { backgroundColor: bch },
          }}
        >
          {bt}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Dl;
